import { usePricing } from '../../hooks/usePricing';
import { useBuilderStore } from '../../store/builderStore';
import { DEFAULT_CURRENCY } from "@printtat/shared";
import { PricingDetails } from "../PricingBreakdown";

interface PriceIndicatorProps {
  defaultOpen?: boolean;
}

const PriceIndicator = ({ defaultOpen }: PriceIndicatorProps) => {
  const breakdown = usePricing();
  const currency = useBuilderStore(
    (s) => s.pricingConfig?.currency ?? DEFAULT_CURRENCY,
  );

  if (!breakdown) return null;

  return <PricingDetails breakdown={breakdown} currency={currency} compact defaultOpen={defaultOpen} />;
};

export { PriceIndicator };
